var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6922 31.515C80.6768 30.4997 79.0306 30.4997 78.0152 31.515L50.1035 59.4268L36.4918 45.815C35.4764 44.7997 33.8302 44.7997 32.8149 45.815C31.7995 46.8304 31.7995 48.4766 32.8149 49.492L48.2629 64.9401C49.1516 65.8288 50.5291 65.9414 51.538 65.2698L51.5444 65.2656C51.6869 65.1714 51.8237 65.0605 51.9526 64.9316L81.6922 35.192C82.7076 34.1766 82.7076 32.5304 81.6922 31.515ZM74.3383 27.8381C77.3844 24.792 82.3231 24.792 85.3692 27.8381C88.4153 30.8842 88.4153 35.8229 85.3692 38.869L55.6295 68.6086C55.2537 68.9844 54.8469 69.3155 54.4165 69.6005C51.3859 71.6158 47.2596 71.2907 44.586 68.617L29.1379 53.1689C26.0918 50.1229 26.0918 45.1842 29.1379 42.1381C32.184 39.092 37.1227 39.092 40.1688 42.1381L50.1035 52.0728L74.3383 27.8381Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9994 15.5996C31.8962 15.5996 15.5994 31.8964 15.5994 51.9996C15.5994 72.1028 31.8962 88.3996 51.9994 88.3996C72.1026 88.3996 88.3994 72.1028 88.3994 51.9996C88.3994 49.6067 88.1689 47.2702 87.7295 45.0102C87.4555 43.6007 88.3761 42.2359 89.7856 41.9618C91.1952 41.6878 92.56 42.6084 92.834 44.0179C93.3365 46.6031 93.5994 49.2719 93.5994 51.9996C93.5994 74.9746 74.9745 93.5996 51.9994 93.5996C29.0244 93.5996 10.3994 74.9746 10.3994 51.9996C10.3994 29.0246 29.0244 10.3996 51.9994 10.3996C60.5011 10.3996 68.4143 12.9527 75.0046 17.3345C76.2004 18.1295 76.5252 19.7434 75.7302 20.9392C74.9352 22.1349 73.3213 22.4597 72.1255 21.6647C66.3619 17.8325 59.4453 15.5996 51.9994 15.5996Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/iconSuccess.28a2f939103d7efbc893a9d105f343f9.svg";
export { ForwardRef as ReactComponent };